import { useCallback, useEffect, useRef, useState } from "react";
import { initialPaging } from "../Constants/paging";
import { CallApiGetListUser, CallApiGetItems } from "../Api/Enforcement";
export const useUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [items, setItems] = useState([]);
  const [paging, setPaging] = useState(initialPaging);
  const pagingRef = useRef(paging);
  const [search, setSearch] = useState("");
  const [user, setUser] = useState(null);
  const [isShowKnbModal, setIsShowKnbModal] = useState(false);
  const initialState = useRef(true);

  useEffect(() => {
    pagingRef.current = paging;
  }, [paging]);

  const getListUsers = useCallback(
    (pageNum) => {
      const data = {
        searchText: search,
        page: pageNum !== undefined ? pageNum : pagingRef.current.pageIndex,
      };

      CallApiGetListUser(data, (res) => {
        if (res.Status === "success") {
          var data = res.Response.data;
          setUsers(data.Items);
          setPaging((prev) => ({
            ...prev,
            next: data.Next,
            previous: data.Previous,
            totalPages: data.TotalPagesCount,
            pageIndex: data.PageIndex,
          }));
        }
      });
    },
    [search]
  );

  const getListItems = useCallback(() => {
    CallApiGetItems((res) => {
      if (res.Status === "success") {
        var data = res.Response.data;
        setItems(data);
      }
    });
  }, []);

  useEffect(() => {
    if (initialState.current) {
      getListUsers();
      getListItems();
      initialState.current = false;
    }
  }, [getListUsers, getListItems]);

  const handleShowKnbModal = (value) => {
    setUser(value);
    setIsShowKnbModal(true);
  };

  const handleCloseKnbModal = () => {
    setUser(null);
    setIsShowKnbModal(false);
    getListUsers();
  };

  return {
    search,
    users,
    isShowKnbModal,
    paging,
    user,
    items,
    handleShowKnbModal,
    handleCloseKnbModal,
    getListUsers,
    setIsShowKnbModal,
    setSearch,
  };
};
